import { Helmet } from 'react-helmet-async';

interface SimpleSEOProps {
  title: string;
  description: string;
  keywords?: string;
}

const truncateTitle = (title: string): string => {
  // Keep titles under 60 characters for better SEO
  return title.length > 60 ? title.substring(0, 57) + '...' : title;
};

export function SimpleSEO({ title, description, keywords }: SimpleSEOProps) {
  // Keep titles concise and focused
  const siteTitle = truncateTitle(`${title} | MdbApp`);
  
  return (
    <Helmet>
      <title>{siteTitle}</title>
      <meta name="description" content={description} />
      {keywords && <meta name="keywords" content={keywords} />}
      
      {/* Open Graph / Facebook */}
      <meta property="og:type" content="website" />
      <meta property="og:title" content={siteTitle} />
      <meta property="og:description" content={description} />
      
      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={siteTitle} />
      <meta name="twitter:description" content={description} />
    </Helmet>
  );
}
